async function getCartData() {
	const response = await fetch('/cart.js');
	const cartData = await response.json();

	window.store.cartData = cartData;

	document.dispatchEvent(
		new CustomEvent('cart:updated', { bubbles: true, detail: { cartData } })
	);

	// Recalculate product prices whenever cart data changes (if pricing helper is available)
	if (typeof modifyProductPrices === 'function') {
		modifyProductPrices();
	}

	return cartData;
}

window.getCartData = getCartData;

async function getProductsData() {
	const response = await fetch(window.theme.routes.root_url + 'products.json?limit=100');
	const productsData = await response.json();
	window.store.productsData = productsData.products;
	return productsData.products;
}

getProductsData();
getCartData().then(d => document.dispatchEvent(new CustomEvent('cart:retrieved:initial', { bubbles: true })));

window.addEventListener('DOMContentLoaded', (event) => {
	const body = document.querySelector('body');
	const footerMenu = body.querySelector('footer');

	if (body.classList.contains('template-blog-subblog')) {
		var numberOfPosts = 30;
		handleLoadMore(numberOfPosts);
		window.addEventListener('handle--load--more', () => handleLoadMore(numberOfPosts));
	}

	if (body.classList.contains('template-blog-structure')) {
		var numberOfPosts = 30;
		window.addEventListener('handle--load--more', () => handleLoadMore(numberOfPosts));
	}

	// Add event listener for mobile footer menu entries
	footerMenu.addEventListener('click', (e) => toggleFooterBlocks(e));

	if (body.classList.contains('template-search')) {
		calculateSearchResults();
	}

	if (body.classList.contains('template-article')) {
		moveContentArticle();
		calculateIframeHeights();
		changeRecommendedProductsURL();
	}

	body.addEventListener('click', (e) => {
		if (e.target.closest('.show-more-grouping') || e.target.classList.contains('show-more-grouping')) {
			e.preventDefault();
			const target = e.target.closest('.show-more-grouping') || e.target;
			const targetGroup = target.dataset.group;
			const sections = document.querySelectorAll('.' + targetGroup);
			sections.forEach((section) => {
				if (section.classList.contains('is-hidden')) {
					section.classList.remove('is-hidden');
					section.classList.add('to-be-hidden');
				}
			});
			target.classList.add('is-hidden');
			target.classList.add('to-be-hidden');
			window.dispatchEvent(new Event('resize'));
		}

		if (e.target.closest('.show-less-grouping') || e.target.classList.contains('show-less-grouping')) {
			e.preventDefault();
			const target = e.target.closest('.show-more-grouping') || e.target;
			const targetGroup = target.dataset.group;
			const sections = document.querySelectorAll('.' + targetGroup);
			sections.forEach((section) => {
				if (section.classList.contains('to-be-hidden')) {
					section.classList.remove('to-be-hidden');
					section.classList.add('is-hidden');
				}
			});
			document.querySelector('.show-more-grouping[data-group="' + targetGroup + '"]').classList.remove('is-hidden');
		}

		if (e.target.closest('.contents') || e.target.classList.contains('contents')) {
			const parentElement = e.target.closest('.columns-layout');
			const form = parentElement.querySelector('#formKlaviyo');
			form.scrollIntoView({ behavior: 'smooth' });
		}

		if (e.target.dataset.action === 'open-modal') {
			e.preventDefault();
			const modalContentId = e.target.dataset.modalContent;
			const modalContent = document.querySelector('#' + modalContentId);

			if (modalContent && window.store.LoadingModal) {
				const clonedContent = modalContent.cloneNode(true);
				clonedContent.classList.remove('is-hidden');
				window.store.LoadingModal.addCloseButton();
				window.store.LoadingModal.addClosingListener();
				window.store.LoadingModal.addContent(clonedContent);
				window.store.LoadingModal.openModal();
			}
		}

		if (e.target.classList.contains('container__item--modal-show-more') || e.target.closest('.container__item--modal-show-more')) {
			const button = e.target.closest('.container__item--modal-show-more') || e.target;
			const parentModal = button.closest('.item__modal');

			const elementsToToggle = parentModal.querySelectorAll('.container__item--flag');
			elementsToToggle.forEach((element) => {
				element.classList.remove('is-hidden');
			});

			if (button.classList.contains('container__item--modal-scroll-down')) {
				parentModal.scrollTo({
					top: parentModal.scrollHeight,
					behavior: 'smooth',
				});
			}

			e.target.parentElement.classList.add('is-hidden');
		}

		if (e.target.classList.contains('button--emphasize-elements') || e.target.closest('.button--emphasize-elements')) {
			const button = e.target.closest('.button--emphasize-elements') || e.target;
			let targetSelectors = button.dataset.targetElements;

			if (!targetSelectors || targetSelectors == '') return;

			targetSelectors = targetSelectors.split(',').map((selector) => selector.trim());

			targetSelectors.forEach((selector) => {
				const targetElements = document.querySelectorAll(selector);
				targetElements.forEach((element) => {
					element.classList.add('emphasize-animation');

					setTimeout(() => {
						element.classList.remove('emphasize-animation');
					}, 1000);
				});
			});
		}

		if (e.target.closest('.thb-quick-search__list-item')) {
			e.preventDefault();

			gtag('event', 'search_bar_click', {
				link_url: e.target.href,
				link_text: e.target.textContent,
				clicked_from: window.location.pathname,
				link_details: window.store ? window.store.location : 'undefined_location'
			});

			window.location.href = e.target.href;
		}
	});
});

document.addEventListener('recheck:charts', (event) => {
	if (document.querySelector('.image-with-text__chart')) {
		window.chartList = window.chartList || [];
		const charts = document.querySelectorAll('.image-with-text__chart canvas');
		charts.forEach((chart, index) => {
			const existingChart = window.chartList.find((item) => item.canvas.id === chart.id);

			if (!existingChart) {
				const type = chart.dataset.chartType;
				const response = buildChart(chart, type);
				window.chartList.push(response);
			}
		});
	}
});

document.addEventListener('init:charts', (event) => {
	if (document.querySelector('.image-with-text__chart')) {
		window.chartList = window.chartList || [];
		const charts = document.querySelectorAll('.image-with-text__chart canvas');
		charts.forEach((chart, index) => {
			const type = chart.dataset.chartType;
			const response = buildChart(chart, type);
			window.chartList.push(response);
		});

		window.addEventListener('resize', () => {
			window.chartList.forEach((chart) => {
				// rebuild the slide
				chart.resize();
			});
		});
	}
});

window.addEventListener('load', (event) => {
	if (document.querySelector('.infographic__to-build')) {
		document.querySelectorAll('.infographic__to-build').forEach((el) => {
			const imageRenderedWidth = el.clientWidth;
			const imageRenderedHeight = el.clientHeight;

			const infographicDomEl = document.createElement('image-infographic');
			infographicDomEl.classList.add('infographic');
			infographicDomEl.innerHTML =
				el.outerHTML.replace(`<img`, `<img data-zoom='1' width=${imageRenderedWidth} height=${imageRenderedHeight}`) +
				`<div class="infographic__buttons flex-container flex-dir-row align-center-middle">
				<span>Zoom</span>
				<button class="button button--toggle button--plus button--gradient-arrow infographic__button infographic__button--zoom-in" aria-label="Plus button">
					<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 13px;height: 13px;fill: #fff;">
						<path d="M3.6 0H4.4V8H3.6V0Z" style="fill: #fff;"/>
						<path d="M3.49692e-08 4.4L0 3.6L8 3.6V4.4L3.49692e-08 4.4Z" style="fill: #fff;"/>
					</svg>
				</button>
				<button class="button button--toggle button--minus button--gradient-arrow infographic__button infographic__button--zoom-out" aria-label="Minus button">
					<svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 13px;height: 13px;fill: #fff;">
						<path d="M3.49692e-08 1.39998L0 0.599976L8 0.599976V1.39998L3.49692e-08 1.39998Z" style="fill: #fff;"/>
					</svg>
				</button>
			</div>`;

			setTimeout(() => {
				el.replaceWith(infographicDomEl);
			}, 500);
		});
	}

	if (document.querySelector('.accordion')) {
		const calculateAccordionHeight = (accordion) => {
			let clientHeight = accordion.clientHeight == 0 ? 100 : accordion.clientHeight;

			accordion.style.setProperty('--client-height', clientHeight + 'px');
		};

		const accordions = document.querySelectorAll('.accordion');
		accordions.forEach((accordion) => {
			if (accordion.clientHeight == 0) {
				setTimeout(() => {
					calculateAccordionHeight(accordion);
				}, 3000);
			} else {
				calculateAccordionHeight(accordion);
			}
		});
	}

	if (document.querySelector('.container__item--modal-trigger')) {
		event.preventDefault();
		const modalTriggers = document.querySelectorAll('.container__item--modal-trigger');
		modalTriggers.forEach((trigger) => {
			trigger.addEventListener('click', (event) => {
				event.preventDefault();

				const modalContent = trigger.querySelector('.item__modal')
					? trigger.querySelector('.item__modal')
					: trigger.parentElement.querySelector('.item__modal');

				if (!modalContent) return;

				const clonedContent = modalContent.cloneNode(true);

				if (!clonedContent.querySelector('.modal__subsections-button')) {
					const children = clonedContent.querySelector('.modal__content').children;

					if (clonedContent.querySelector('.container__item--initial-flag')) {
						const initialFlag = clonedContent.querySelector('.container__item--initial-flag');
						const indexInitialFlag = Array.from(children).indexOf(initialFlag);
						const restOfTheChildren = Array.from(children).slice(indexInitialFlag + 1);
						restOfTheChildren.forEach((child) => {
							child.classList.add('is-hidden');
							child.classList.add('container__item--flag');
						});

						initialFlag.insertAdjacentHTML(
							'afterend',
							`<div class="item__modal-buttons flex-container flex-dir-row align-center-middle">
								<button class="button button--white button--border-orange container__item--modal-show-more" role="button" title="Read more"><span>Read more</span></button>
								${(clonedContent.textContent || clonedContent.innerText).indexOf('klaviyo-form') > -1
								? `<button class="button  button--border-green  button--white  container__item--modal-show-more container__item--modal-scroll-down " role="button" title="Be notified"><span>Be notified </span></button>`
								: ``
							}
							</div>`
						);

						initialFlag.remove();
					} else if (children.length >= 10) {
						const restOfTheChildren = Array.from(children).slice(10);
						restOfTheChildren.forEach((child) => {
							child.classList.add('is-hidden');
							child.classList.add('container__item--flag');
						});

						children[children.length - 1].insertAdjacentHTML(
							'afterend',
							`<div class="item__modal-buttons flex-container flex-dir-row align-center-middle">
								<button class="button button--white button--border-orange container__item--modal-show-more" role="button" title="Read more"><span>Read more</span></button>
								${(clonedContent.textContent || clonedContent.innerText).indexOf('klaviyo-form') > -1
								? `<button class="button  button--border-green  button--white  container__item--modal-show-more container__item--modal-scroll-down " role="button" title="Be notified"><span>Be notified </span></button>`
								: ``
							}
							</div>`
						);
					}
				}

				window.store.LoadingModal.addContent(clonedContent);
				window.store.LoadingModal.addCloseButton();
				window.store.LoadingModal.addClosingListener();
				window.store.LoadingModal.openModal();
				clonedContent.classList.remove('is-hidden');

				if (trigger.closest('.accordion')) {
					const accordionHeader = trigger.closest('.accordion-item')
					accordionHeader.removeAttribute('open');
				}
			});
		});
	}
});

if (window.Shopify.designMode) {
	window.addEventListener('load', function (e) {
		const hiddenParents = document.querySelectorAll('.klaviyo-form__hidden');
		hiddenParents.forEach((parent) => parent.classList.remove('klaviyo-form__hidden'));
	});
} else {
	window.addEventListener('klaviyoForms', function (e) {
		if (e.detail.type == 'embedOpen') {
			const selector = `.klaviyo-form-${e.detail.formId}`;
			const element = document.querySelector(selector);

			if (!element) return;

			const hiddenParent = element.closest('.klaviyo-form__hidden');

			if (hiddenParent) {
				hiddenParent.classList.remove('klaviyo-form__hidden');
			}
		}
	});
}

function changeRecommendedProductsURL() {
	if (!document.querySelector(".blog-post-sidebar .product-cart-item-small")) return;

	if (window.store && window.store.articleHandle) {
		const recommendedProducts = document.querySelectorAll(".blog-post-sidebar .product-cart-item-small");
		recommendedProducts.forEach((product) => {
			const link = product.querySelectorAll("a");
			if (link.length > 0) {
				link.forEach((link) => {
					const newUrl = new URL(link.href);
					newUrl.searchParams.set("src", window.store.articleHandle);
					link.href = newUrl.toString();
				});
			}
		});
	}
}

function moveContentArticle() {
	const leftSideBar =
		document.querySelectorAll('.blog-post-detail__sidebar').length > 1 ? document.querySelectorAll('.blog-post-detail__sidebar')[0] : null;
	const rightSideBar =
		document.querySelectorAll('.blog-post-detail__sidebar').length > 1 ? document.querySelectorAll('.blog-post-detail__sidebar')[1] : null;

	if (!leftSideBar || !rightSideBar) return;

	const newsletterBox = document.querySelector('.blog-post-sidebar blog-newsletter');

	/// AICI AM RAMAS
}

function toggleFooterBlocks(event) {
	if (window.innerWidth > 769 || !event.target.classList.contains('block__header')) return;

	event.preventDefault();
	event.target.parentElement.classList.toggle('navbar__block--open');
}

// sticky newsletter box on join ou pack page
function stickyNewsletterBox() {
	if (document.querySelector('.template-page-vm-join-our-pack')) {
		const newsletterBox = document.querySelector('blog-newsletter');
		const blocks = document.querySelector('.join-our-pack__blocks');

		if (!newsletterBox || !blocks) return; // <-- add this line

		if (window.innerWidth < 1067) {
			blocks.parentNode.insertBefore(newsletterBox, blocks.previousSibling);
		}
	}
}

function calculateSearchResults() {
	const searchResults = document.querySelector('#totalResults');
	const productResults = document.querySelector('#productCount');
	const articleResults = document.querySelector('#articleCount');
	const pageResults = document.querySelector('#pageCount');
	let finalMarkup = '';

	if (!searchResults) return;

	finalMarkup += productResults ? `<strong>${productResults.innerHTML}</strong> products, ` : '';
	finalMarkup += articleResults ? `<strong>${articleResults.innerHTML}</strong> articles, ` : '';
	finalMarkup += pageResults ? `<strong>${pageResults.innerHTML}</strong> pages, ` : '';
	searchResults.innerHTML = finalMarkup.trim().slice(0, -1) + ` displayed`;
	searchResults.classList.remove('loading');
}

// Build charts for section chart-with-image
function buildChart(chart, type) {
	const data = JSON.parse(chart.dataset.chartData);
	const labels = data.map((item) => item.label);
	const bgColors = data.map((item) => item.color);
	const barsData = data.map((item) => +item.data);
	const tooltips = data.map((item, index) => {
		return { index: index, tooltip: item.tooltip };
	});
	const ctx = chart.getContext('2d');
	const config = {
		labels: labels,
		datasets: [
			{
				type: type,
				label: chart.dataset.chartLabel,
				backgroundColor: bgColors,
				data: barsData,
			},
		],
	};

	const options = {
		aspectRatio: 0.7,
		maintainAspectRatio: false,
		responsive: true,
		scales:
			type === 'bar'
				? {
					yAxes: [
						{
							stacked: true,
							gridLines: {
								display: true,
								color: 'rgba(79,79,79,0.2)',
							},
						},
					],
					xAxes: [
						{
							gridLines: {
								display: false,
							},
						},
					],
				}
				: false,
		tooltips: {
			callbacks: {
				label: function (tooltipItem) {
					return tooltips[tooltipItem.index].tooltip;
				},
			},
		},
	};

	chart.parentElement.style.minHeight = '450px';

	return new Chart(ctx, {
		type: type,
		data: config,
		options: options,
	});
}

function preloadHDTData() {
	function getUrlVars() {
		try {
			var vars = {};
			let newUrl = '';

			if (
				window.location.href.includes('dogname') ||
				window.location.href.includes('uname') ||
				window.location.href.includes('uemail') ||
				window.location.href.includes('doggender')
			) {
				newUrl = window.location.href;
			} else if (window.location.search && window.location.search.length > 0) {
				const decodedSearch = atob(window.location.search.slice(1));
				newUrl = window.location.origin + window.location.pathname + '?' + decodedSearch;
			}
			var parts = newUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
				vars[key] = value;
			});
			return vars;
		} catch (e) {
			console.log('getUrlVars Err', e);
			return {};
		}
	}

	const checkIfEmailConfirmationPage = () => {
		if (!localStorage.getItem('pd_user_path')) return;

		const steps = JSON.parse(localStorage.getItem('pd_user_path'));

		if (steps.length === 7) {
			const urlParamr = getUrlVars();
			const from = urlParamr['from'];

			if (from !== 'hdtmail') {
				localStorage.setItem('pd_user_path', '[[0,0]]');
			} else {
				history.pushState({}, null, window.location.origin + window.location.pathname);
			}
		}
	};

	checkIfEmailConfirmationPage();
	var urlParamr = getUrlVars();

	var loadInfoScreen = urlParamr['infoscreen'];
	if (loadInfoScreen == 'true') {
		localStorage.setItem('pd_user_path', '[[0,0],[2,0]]');
	}

	var pa = urlParamr['dogname'];
	var pb = urlParamr['dogweight'];
	var pc = urlParamr['weighttype'];
	var pd = urlParamr['dogbreed'];
	var pe = urlParamr['uname'];
	var pf = urlParamr['uemail'];
	var pg = urlParamr['doggender'];
	var ph = urlParamr['agetype'];
	var dage = urlParamr['dogage'];
	var healthTags = urlParamr['healthtags'];
	var from = urlParamr['from'];

	if (typeof from != 'undefined' && from == 'homepage') {
		var newUserDetails = {
			dogweight_type: pc,
			dogname: pa,
			dogweight: pb,
			username: pe,
			emailaddress: pf,
			dogbreedtype: pd,
			doggender: pg,
			dogage: dage,
			dogfoodtype: [],
			dogage_type: ph,
			to_subscribe: true,
			to_course: true,
			healthTags: healthTags ? healthTags.replace(/%20/g, ' ') : '',
		};

		if (typeof healthTags != 'undefined' && healthTags != '') {
			let responses = [];
			let responsesTags = [];
			let newHealthTags = healthTags.replace(/%20/g, ' ').split(',');
			newHealthTags.forEach((tag, index) => {
				if (window.store.healthConcers && window.store.healthConcers.length != 0) {
					window.store.healthConcers.forEach((concern) => {
						if (tag.toLowerCase() == concern.value.toLowerCase()) {
							responses.push(concern.index);
							responsesTags.push(concern.value);
						}
					});
				}
			});
			if (!newHealthTags.includes('general articles')) newHealthTags.push('general articles');

			responses.sort(function (a, b) {
				return a - b;
			});
			const object = {
				'0_0': [0],
				'1_0': [1],
				'1_1_0': [...responses],
				'1_1': [],
			};

			localStorage.setItem('pd_user_path', '[[0,0],[1,0],[1,1],[1,3]]');
			localStorage.setItem('pd_user_answers', JSON.stringify(object));
			localStorage.setItem('pd_user_details', JSON.stringify(newUserDetails));
			localStorage.setItem('pd_article_tags', JSON.stringify(responsesTags));
			localStorage.setItem('pd_last_visit', new Date().getTime());
		} else {
			localStorage.setItem('pd_user_path', '[[0,0],[1,0],[1,3]]');
			localStorage.setItem('pd_user_answers', '{"0_0":[0],"1_0":[0]}');
			localStorage.setItem('pd_user_details', JSON.stringify(newUserDetails));
			localStorage.setItem('pd_article_tags', JSON.stringify(['general articles']));
			localStorage.setItem('pd_last_visit', new Date().getTime());
		}

		history.pushState({}, null, window.location.origin + window.location.pathname);

		localStorage.setItem('pd_source', 'internal');
		document.querySelector('#quizApp').classList.add('is-internal');
	} else {
		if (typeof pa != 'undefined' && typeof pb != 'undefined' && typeof pc != 'undefined') {
			pa = decodeURI(pa);
			$('.quizAppHeading h1').text('Congratulations on completing your recipe.');
			$('.quizAppHeading h2').text("Let's create " + pa + "'s supplement plan");
			$('.quizAppHeading h3').css('display', 'none');
			window.store.recipeMakerSource = true;
			pd = decodeURI(pd);

			if (pc == 'lbs') {
				pc = 'lb';
			}
			try {
			} catch (e) {
				console.log('preloadHDTData Err', e);
			}
			var newUserDetails = {
				dogweight_type: pc,
				dogname: pa,
				dogweight: pb,
				username: pe,
				emailaddress: pf,
				dogbreedtype: pd,
				doggender: pg,
				to_subscribe: true,
				to_course: true,
				dogage: dage,
				dogage_type: ph,
				dogfoodtype: ['Raw Food'],
			};
			localStorage.setItem('pd_user_path', '[[0,0]]');
			localStorage.setItem('pd_user_details', JSON.stringify(newUserDetails));
			localStorage.setItem('pd_last_visit', new Date().getTime());
			localStorage.setItem('pd_source', 'external');
			document.querySelector('#quizApp').classList.add('is-external');
			history.pushState({}, null, window.location.origin + window.location.pathname);
		} else {
			const today = new Date().getTime();
			const lastVisit = localStorage.getItem('pd_last_visit');
			localStorage.setItem('pd_source', 'internal');
			document.querySelector('#quizApp').classList.add('is-internal');

			if (lastVisit) {
				const diff = today - lastVisit;
				const diffDays = Math.floor(diff / (1000 * 60 * 60 * 24));
				if (diffDays >= 30) {
					localStorage.removeItem('pd_user_path');
					localStorage.removeItem('pd_user_answers');
					localStorage.removeItem('pd_user_details');
					localStorage.removeItem('pd_article_tags');
					localStorage.setItem('pd_last_visit', today);
				} else {
					localStorage.setItem('pd_last_visit', today);
				}
			} else {
				localStorage.setItem('pd_last_visit', today);
			}
		}
	}
}

function handleLoadMore(numberOfPosts) {
	const allPosts = document.querySelectorAll('.blog-post');
	const mainBlogContent = document.querySelector('.main-blog__content');
	const loadMoreButton = `<button class="button button--gradient-green button--full content__load-more">
			Load more
		</button>`;

	modifyPosts(allPosts, numberOfPosts);

	if (allPosts.length <= numberOfPosts) return;

	mainBlogContent.insertAdjacentHTML('beforeend', loadMoreButton);
	const loadMore = document.querySelector('.content__load-more');
	loadMore.onclick = (event) => {
		if (event.target.classList.contains('content__show-less')) {
			numberOfPosts = 30;
			modifyPosts(allPosts, numberOfPosts);
			loadMore.classList.remove('content__show-less');
			loadMore.innerHTML = 'Load more';
		} else {
			numberOfPosts += 30;
			modifyPosts(allPosts, numberOfPosts);
		}
	};
}

function modifyPosts(allPosts, numberOfPosts) {
	allPosts.forEach((post, index) => {
		if (index >= numberOfPosts) {
			post.classList.add('is-hidden');
		} else {
			post.classList.remove('is-hidden');
		}
	});

	if (allPosts.length <= numberOfPosts) {
		const loadMore = document.querySelector('.content__load-more');
		if (loadMore) {
			loadMore.classList.add('content__show-less');
			loadMore.innerHTML = 'Show less';
		}
	}
}

function fetchPageTemplate(event) {
	const { handle, selector } = event.detail;

	fetch(`${window.theme.routes.root_url}pages/subscriptions-quiz?view=${handle}`)
		.then((response) => response.text())
		.then((html) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const sections = doc.querySelectorAll('#main-content .shopify-section');

			sections.forEach((section) => {
				document.querySelector(selector).append(section);
			});

			typeof window.modifyProductPrices === 'function' && window.modifyProductPrices();
		})
		.catch((error) => console.error(error));
}

function calculateIframeHeights() {
	const iframes = document.querySelectorAll('.blog-post-detail iframe');
	iframes.forEach((iframe) => {
		if (iframe.src.includes('buzzsprout.com')) return;

		const newDivParent = document.createElement('span');
		newDivParent.classList.add('post-content__iframe-container');
		iframe.insertAdjacentElement('beforebegin', newDivParent);
		newDivParent.appendChild(iframe);
	});
}


function returnHeaderBasedOnTemplate(header) {
	// 0-17 Optimize space on PDPs
	const templateProduct = window.store.templateType === 'product';
	const smallScreen = window.innerWidth < 768;
	const entireHeader = document.querySelector('#shopify-section-header');
	const headerSection = document.querySelector('.header-section');
	const trustpilotTopBar = document.querySelector('.trustpilot-top-bar');
	const wasMoved = trustpilotTopBar && entireHeader && !entireHeader.contains(trustpilotTopBar);

	if (templateProduct && smallScreen && trustpilotTopBar && entireHeader && headerSection) {
		header = trustpilotTopBar;
		trustpilotTopBar.style.position = 'sticky';
		trustpilotTopBar.style.top = '0';
		trustpilotTopBar.style.zIndex = '49';
		headerSection.style.position = 'inherit';
		entireHeader.before(trustpilotTopBar);
	} else if (templateProduct && !smallScreen && wasMoved) {
		entireHeader.parentNode.insertBefore(trustpilotTopBar, entireHeader);
		trustpilotTopBar.style.position = '';
		trustpilotTopBar.style.top = '';
		trustpilotTopBar.style.zIndex = '';
		if (headerSection) headerSection.style.position = '';
		header = entireHeader;
	} else {
		header = entireHeader;
	}

	return header;
}

if (window.location.pathname === `${window.theme.routes.root_url}pages/healthydogtool`) preloadHDTData();
window.addEventListener('DOMContentLoaded', stickyNewsletterBox);
window.addEventListener('resize', stickyNewsletterBox);
window.addEventListener('fetch--page--template', fetchPageTemplate);

function setRootVariables() {
	let header = document.querySelector('#shopify-section-header');

	header = returnHeaderBasedOnTemplate(header);
	
	if (header) {
		const headerHeight = header.offsetHeight;
		document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
		document.documentElement.style.setProperty('--header-section-height', headerHeight + 'px');
		document.documentElement.style.setProperty('--header-height-mobile', headerHeight + 'px');
	}

	const search = document.querySelector('.top-menu__search-bar');
	if (search) {
		const distanceFromTop = search?.getBoundingClientRect()?.top || 0;
		const distanceFromTopValue = distanceFromTop.toFixed(2) + 'px';

		document.documentElement.style.setProperty('--search-bar-distance-from-top', distanceFromTopValue);
	}

	const heightScrollableNavbarProducts = document.querySelector('scrollable-navbar-products');

	if (heightScrollableNavbarProducts) {
		document.documentElement.style.setProperty('--scrollable-navbar-products-height', heightScrollableNavbarProducts.offsetHeight + 'px');
	}
}

/**
 * Formats amount using window.store.currencyFormat (e.g. '€{{amount_with_comma_separator}} EUR').
 * Replaces {{placeholder}} with the formatted amount, keeps prefix/suffix.
 * @param {number} amount - Price in main unit (e.g. 1234.56)
 * @returns {string}
 */

function formatMoney(amount) {
	var format = (window.store && window.store.currencyFormat) || '{% raw %}{{amount}}{% endraw %}';
	var match = format.match(/\{\{([^}]+)\}\}/);
	if (!match) return String(amount);
	var placeholder = match[1];
	var decimals = amount.toFixed(2);
	var parts = decimals.split('.');
	var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	var decPart = parts[1];
	var formattedAmount;
	if (placeholder === 'amount_with_comma_separator') {
		formattedAmount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decPart;
	} else if (placeholder === 'amount_no_decimals') {
		formattedAmount = Math.round(amount).toLocaleString('en-US', { maximumFractionDigits: 0 });
	} else if (placeholder === 'amount_with_comma_separator_and_no_decimals') {
		formattedAmount = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	} else {
		formattedAmount = intPart + '.' + decPart;
	}
	return format.replace(match[0], formattedAmount);
}

window.addEventListener('DOMContentLoaded', setRootVariables);
window.addEventListener('resize', setRootVariables);

function modifyProductPrices() {
	console.log("modifyProductPrices");
	
	if (Object.keys(window.store.cartData || {}).length === 0 || Object.keys(window.store.productsData || {}).length === 0) return;

	const allProductGridsPrices = document.querySelectorAll('.price');
	const allProductGridsPricesToBeModified = Array.from(allProductGridsPrices).filter((price) => !price.dataset.disableGeneralPriceAdjustment);

	if (allProductGridsPricesToBeModified.length === 0) return;

	fetch(`${window.theme.routes.root_url}collections/all?view=price-server`).then((response) => response.text()).then((html) => {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');
		const prices = doc.querySelectorAll('.price');
		allProductGridsPricesToBeModified.forEach((price) => {
			const productHandle = price.dataset.productHandle;
			const productPrice = Array.from(prices).find((p) => p.dataset.productHandle === productHandle);
			if (productPrice) {
				price.innerHTML = productPrice.innerHTML;
			}
		});
	});
}

window.modifyProductPrices = modifyProductPrices;